<mat-dialog-content style="max-height: unset" class="flex flex-col h-full">
<!--    <div>-->
<!--        <button app-button (click)="addBidderFromFile()">bieter hinzufügen</button>-->
<!--        <mat-form-field class="searchfield" floatLabel="never" color="accent" *ngIf="ShowSearchBar$ | async">-->
<!--            <input [formControl]="SearchForm" matInput #input type="text" placeholder="Suche" />-->
<!--        </mat-form-field>-->
<!--        <button app-round-button matTooltipPosition="left" [matTooltip]="(ShowSearchBar$ | async) ? 'Ausblenden' : 'Suche'" (click)="ShowSearchBar$.next(!this.ShowSearchBar$.value)" style="margin-left: 0.5rem; top: 0.8rem">-->
<!--            <fa-icon [icon]="(ShowSearchBar$ | async) ? 'times' : 'search'"></fa-icon>-->
<!--        </button>-->
<!--    </div>-->

    <div class="scrollable-content grow">
        <div class="flex" *ngIf="filteredVisibleNodes$ | async as nodes; else loading">
            <div class="position-table-wrapper">
                <div class="position-table-content">
                    <div class="bidder-scroll-wrapper" style="visibility: hidden; pointer-events: none">
                    <mat-card class="mat-card-bidder" >
                        <div>
                        <div class="arrow-buttons">
                            <button  mat-button><fa-icon icon="arrow-left"></fa-icon></button>
                        </div>
                        </div>
                        <button style="margin-top: 0.3rem" app-round-button Color="red">
                            <fa-icon icon="trash"></fa-icon>
                        </button>
                        <mat-form-field style="width: 99%; display: block">
                            <input matInput placeholder="" type="number" />
                        </mat-form-field>
                        <mat-form-field style="width: 99%; display: block">
                            <input matInput placeholder="" type="number" />
                        </mat-form-field>
                        <div></div>
                        <div></div>
                    </mat-card>
                    </div>
                    <mat-form-field class="searchfield" floatLabel="never" color="accent">
                    <input  [formControl]="SearchForm" matInput #input type="text" placeholder="Suche" />
                    </mat-form-field>

                    <div >
                        <span *ngIf="nodes.length > 0" class="sum-text">Summen in €</span>
                        <table class="position-table price-comparison-table">
                            <col style="width: 15%" />
                            <col style="width: 50%" />
                            <col style="width: 10%" />
                            <col style="width: 10%" />
                            <col style="width: 15%" />
                            <thead>
                                <tr></tr>
                                <tr>
                                    <th>Position</th>
                                    <th>Bezeichnung</th>
                                    <th>Menge</th>
                                    <th>Einheit</th>
                                    <th>Preis-Ek in €</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let node of nodes; let i = index; trackBy: trackByNodeId">
                                    <tr>
                                        <!--                                [style.padding-left]="node.level + 'rem'"-->
                                        <td>
                                            <button mat-icon-button [attr.aria-label]="'Toggle ' + node.position" *ngIf="node.expandable" (click)="tree.treeControl.toggle(node)" class="w-4 h-4">
                                                <fa-icon [icon]="tree.treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'"></fa-icon>
                                            </button>
                                            <span *ngIf="!node.expandable" class="w-4"></span>
                                            {{ node.data.ItemNumber }}
                                        </td>
                                        <td class="cell-with-button">
                                            <span class="text">
                                                {{ node.data.Information }}
                                            </span>
                                            <button (click)="longInformationClick(node)" mat-icon-button matTooltip="Langtext anzeigen" class="w-4 h-4">
                                                <fa-icon icon="paragraph"></fa-icon>
                                            </button>
                                        </td>
                                        <td>{{ node.data?.Quantity }}</td>
                                        <td>{{quantityTypeNames.get(node.data.QuantityTypeId) }}</td>
                                        <td class="price">{{ node.data.CostAmount | number: '1.2-2':'de' }}</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <app-arl-tree *ngIf="arlFilter$ | async as filter" #tree [data]="data" [getChildren]="getChildren" [getPosition]="getPosition" [itemFilter]="filter" style="display: none">
                        <ng-container *appArlTreeRow="let node; let e = expanded; let i = index"> </ng-container>
                    </app-arl-tree>
                </div>
            </div>

            <div class="bidder-scroll-wrapper">
                <div class="bidder-container">
                    <ng-container *ngIf="bidderData?.length > 0; else noBidders">
                    <div *ngFor="let bidder of bidderData; let i = index trackBy: trackByBidderIndex" style="min-width: 19rem; flex-shrink: 0" [formGroup]="bidder.formGroup" >
                        <mat-card class="my-4 mat-card-bidder">
                            <div>{{ bidder.fileName }}
                                <div class="arrow-buttons">
                                <button [disabled]="i === 0" [matTooltip]="'Bieter verschieben'" mat-button (click)="moveBidder(i, false)"><fa-icon icon="arrow-left"></fa-icon></button>
                                <button [disabled]="i === bidderData.length - 1" [matTooltip]="'Bieter verschieben'" mat-button (click)="moveBidder(i, true)"><fa-icon icon="arrow-right"></fa-icon></button>
                                </div>
                                </div>


                            <button style="margin-top: 0.3rem" app-round-button Color="red" (click)="deleteBidder(i)" [matTooltip]="'Löschen'">
                                <fa-icon icon="trash"></fa-icon>
                            </button>
                            <mat-form-field style="width: 99%; display: block">
                                <input matInput [placeholder]="'Rabatt:'" formControlName="rabatt" type="number" />
                                <span class="suffix" matSuffix>%</span>
                            </mat-form-field>

                            <mat-form-field style="width: 99%; display: block">
                                <input matInput [placeholder]="'Skonto:'" formControlName="skonto" type="number" />
                                <span class="suffix" matSuffix>%</span>
                            </mat-form-field>
                            <div></div>
                            <div>Bieter: {{ bidder.bidderName }}</div>
                        </mat-card>

                        <table class="price-comparison-table" [formGroup]="bidder.formGroup">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="price">
                                        {{ bidder.formGroup.controls.sumPicePrice.value | number: '1.2-2':'de' }}
                                    </th>
                                    <th class="price">
                                        {{ bidder.formGroup.controls.sumDiscountPrice.value | number: '1.2-2':'de' }}
                                    </th>
                                    <th
                                        class="price"
                                        [ngClass]="{
                                            'max-value': bidder.formGroup.controls.sumSumPrice.value === maxSumSumPrice,
                                            'min-value': bidder.formGroup.controls.sumSumPrice.value === minSumSumPrice
                                        }"
                                    >
                                        {{ bidder.formGroup.controls.sumSumPrice.value | number: '1.2-2':'de' }}
                                    </th>
                                </tr>
                                <tr>
                                    <th>
                                        <span [matTooltip]="!bidder.formGroup.controls.selectAble.value ? 'Eine oder mehere Positionen in Datei nicht vorhanden, oder fehlerhaft' : null">

                                            <mat-checkbox [disabled]="!bidder.formGroup.controls.selectAble.value" [indeterminate]="isBidderIndeterminate(i)" [checked]="isBidderSelected(i)" (change)="selectBidder(i, $event.checked)"></mat-checkbox>
                                        </span>
                                    </th>
                                    <th>EP Original in €</th>
                                    <th>EP Kondition in €</th>
                                    <th>GP in €</th>
                                </tr>
                            </thead>
                            <tbody formGroupName="positions">
                                <ng-container *ngFor="let node of nodes; let d = index; trackBy: trackByNodeId">
                                        <tr *ngIf="getPositionGroup(node, bidder.formGroup.controls.positions) as positionControl" [formGroupName]="node.data.Id.toString()">
<!--                                    <tr *ngIf="bidder.formGroup.controls.positions.controls[node.data.Id.toString()] as positionControl" [formGroupName]="node.data.Id.toString()">-->
                                        <td>
                                            <span [matTooltip]="!positionControl.controls.selectAble.value ? 'Position in Datei nicht vorhanden, oder fehlerhaft' : null">
                                                <app-hint-icon *ngIf="positionControl.controls.changed.value" hint="Position wurde seitdem letzen hinzufügen verändert"></app-hint-icon>
                                                <mat-checkbox (change)="selecetPosition(i, positionControl.controls.arlId.value, $event.checked)" formControlName="selected" ></mat-checkbox>
                                            </span>
                                        </td>
                                        <td class="price">{{ positionControl.controls.isGroup.value ? '-' : (positionControl.controls.piecePrice.value | number: '1.2-2':'de') }}</td>
                                        <td class="price">{{ positionControl.controls.isGroup.value ? '-' : (positionControl.controls.discountPrice.value | number: '1.2-2':'de') }}</td>
                                        <td
                                            class="price"
                                            [ngClass]="{
    'max-value': positionControl.controls.sumPrice.value === maxSumPricePerNode[node.data.Id],
    'min-value': positionControl.value.sumPrice === minSumPricePerNode[node.data.Id],
  }"
                                        >
                                            {{ !positionControl.controls.selectAble.value ? '-' : (positionControl.controls.sumPrice.value | number: '1.2-2':'de') }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    </ng-container>
                    <ng-template #noBidders>
                        <div >
                            <h3>
                            Bieter hinzufügen&nbsp;<fa-icon icon="arrow-right"></fa-icon>
                            </h3>
                        </div>
                    </ng-template>
                    <button class="add-button" [matTooltip]="'Bieter hinzufügen'" app-round-button [matMenuTriggerFor]="fileSuply"><fa-icon icon="plus"></fa-icon></button>
<!--                        <button class="add-button" [matTooltip]="'Bieter hinzufügen'" app-round-button (click)="addBidderFromFile()"><fa-icon icon="plus"></fa-icon></button>-->

                    <mat-menu #fileSuply="matMenu">
                        <ng-template matMenuContent>
                            <button mat-menu-item (click)="onSelectFileClick()">Datei hinzufügen</button>
                            <button mat-menu-item (click)="onUploadFileClick()">Datei hochladen</button>
                        </ng-template>
                    </mat-menu>
                </div>
            </div>
        </div>
        <ng-template #loading>
            <app-loading>
            </app-loading>
        </ng-template>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="actions">
    <button app-button Inverted class="cancelButton" type="button" (click)="closeDialog()" Color="cancel">Abbrechen</button>

    <button app-button class="saveButton" (click)="save()" Color="green">Speichern</button>
</mat-dialog-actions>
